import script from "./PandoraCards.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraCards.vue?vue&type=script&setup=true&lang=js"

import "./PandoraCards.vue?vue&type=style&index=0&id=1030fb61&lang=css"

const __exports__ = script;

export default __exports__